<template>
    <el-table-column label="Asin" width="180" align="center">
        <template slot-scope="scope">
            <div class="asinBox">
                <icon-svg
                    :icon-class="(scope.row.state || '').toUpperCase()"
                    style="font-size: 24px;margin-left:5px;"
                ></icon-svg>
                <span @click="jumpUrl(scope.row)"
                      style="color: blue;cursor: pointer">{{ scope.row.asin }}</span>

                <div class="hotBox" v-if="needHot">
                    <el-tooltip class="item" effect="dark" placement="top">
                        <div slot="content">
                            生成时间: {{scope.row.small_bestseller_time}}<br/>
                            核对时间: {{scope.row.small_bestseller_collate_time}}<br/>
                        </div>
                        <span>
                            <img src="@/assets/hot.png" style="width:12px;height:12px;display: inline-block" v-show="[1,2].includes(scope.row.is_small_bestseller)"/>
                            <span v-show="scope.row.is_small_bestseller === 1">爆-自然</span>
                            <span v-show="scope.row.is_small_bestseller === 2">爆-低Acos</span>
                        </span>
                    </el-tooltip>
                </div>
            </div>
        </template>
    </el-table-column>
</template>

<script>
    export default {
        name: 'tableAsinColumn',
        props: {
            needHot: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {}
        },
        methods: {
            jumpUrl(data) {
                let url = ''
                const state = data.state.toLowerCase()
                switch (state) {
                    case 'us':
                        url = 'https://www.amazon.com/dp/' + data.asin
                        break
                    case 'uk':
                        url = 'https://www.amazon.co.uk/dp/' + data.asin
                        break
                    case 'de':
                        url = 'https://www.amazon.de/dp/' + data.asin
                        break
                    case 'fr':
                        url = 'https://www.amazon.fr/dp/' + data.asin
                        break
                    case 'it':
                        url = 'https:// www.amazon.it/dp/' + data.asin
                        break
                    case 'es':
                        url = 'https://www.amazon.es/dp/' + data.asin
                        break
                    case 'ca':
                        url = 'https://www.amazon.ca/dp/' + data.asin
                        break
                    case 'mx':
                        url = 'https://www.amazon.mx/dp/' + data.asin
                        break
                    case 'br':
                        url = 'https://www.amazon.br/dp/' + data.asin
                        break
                    case 'nl':
                        url = 'https://www.amazon.nl/dp/' + data.asin
                        break
                    case 'se':
                        url = 'https://www.amazon.se/dp/' + data.asin
                        break
                    case 'pl':
                        url = 'https://www.amazon.pl/dp/' + data.asin
                        break
                    case 'be':
                        url = 'https://www.amazon.be/dp/' + data.asin
                        break
                    case 'tr':
                        url = 'https://www.amazon.tr/dp/' + data.asin
                        break
                }
                window.open(url, '_blank')
            },
        }
    }
</script>
<style lang="scss" scoped>
    .asinBox {
        position: relative;
        padding-top: 20px;

        .hotBox {
            position: absolute;
            right: -10px;
            top: 0;
            background: rgba(255, 0, 0, 0.2);
            padding: 0 8px;
            border-radius: 8px;
            cursor: pointer;
        }
    }
</style>
